export * from '@contentlayer2/client';
//# sourceMappingURL=index.js.map